
import { defineComponent, PropType } from 'vue'
import { iBusinessModel } from '../../../Metaweb'
import Textarea from 'primevue/textarea'

export default defineComponent({
    name: 'metaweb-filter-tab',
    components: { Textarea },
    props: { selectedBusinessModel: { type: Object as PropType<iBusinessModel | null> }, propMeta: { type: Object } },
    emits: ['metaUpdated'],
    data() {
        return {
            meta: null as any,
            businessModel: null as iBusinessModel | null
        }
    },
    watch: {
        selectedBusinessModel() {
            this.loadMeta()
            this.loadBusinessModel()
        }
    },
    created() {
        this.loadMeta()
        this.loadBusinessModel()
    },
    methods: {
        loadMeta() {
            this.meta = this.propMeta as any
        },
        loadBusinessModel() {
            this.businessModel = this.selectedBusinessModel as iBusinessModel
        },
        updateMeta() {
            setTimeout(() => {
                this.$emit('metaUpdated')
            }, 250)
        }
    }
})
